import React, {useState, useRef, useEffect} from "react";
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import ReactQuill, {Quill} from 'react-quill'
import {Fieldset} from "primereact/fieldset";
import {Card} from 'primereact/card';
import {Panel} from 'primereact/panel';
import Spinner from '../../spinner/Spinner'
import {InputText} from "primereact/inputtext";
import axios from "axios";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import * as management from "../../actions/management";
import {MultiSelect} from "primereact/multiselect";
import {Dropdown} from "primereact/dropdown";
import {none} from "html-webpack-plugin/lib/chunksorter";
import {Dialog} from "primereact/dialog";
import {TabPanel, TabView} from "primereact/tabview";
import {FileUpload} from "primereact/fileupload";
import {Message} from "primereact/message";
import {DataView} from "primereact/dataview";
import {Checkbox} from "primereact/checkbox";


function MyEditor() {


}

MyEditor.modules = {
    // ImageResize: {
    //     modules: ['Resize', 'DisplaySize', 'Toolbar']
    // },
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],

        [{'header': 1}, {'header': 2}],               // custom button values
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
        [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
        [{'direction': 'rtl'}],                         // text direction

        [{'size': ['small', false, 'large', 'huge']}],
        ["link"], // dropdown with defaults from theme
        [{'font': []}],
        [{align: ''}, {align: 'center'}, {align: 'right'}, {align: 'justify'}],

        [{'color': []}, {'background': []}],
        ['clean'],


    ],


};

MyEditor.formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
    "video",
    "code-block",
    "align"


];


const CmsSendMail = props => {
    const toast = useRef(null);
    const [mailText, setMailText] = useState('');
    const [mailTitle, setMailTitle] = useState('');
    const send_mail_role = localStorage.getItem('send_mail') ? true : false;
    const [loadingState, setLoadingState] = useState(false)
    const [mailUser, setMailUser] = useState(null);
    const [codes, setCodes] = useState([]);
    const [receiverName, setReceiverName] = useState('');
    const [cmflDialog, setCmflDialog] = useState(false);
    const [activeIndex1, setActiveIndex1] = useState(0);
    const [fileTypeID, setFileTypeID] = useState(null);
    const [cmflFilePath, setCmflFilePath] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [cmflID, setCmflID] = useState('');
    const [cmflFileName, setCmflFileName] = useState('');
    const [cmflDetail, setCmflDetail] = useState('');
    const [typeID, setTypeID] = useState(null);
    const [cities, setCities] = useState([]);
    const [fileTypeList, setFileTypeList] = useState([]);


    useEffect(() => {
            getFileTypeList()
            getContentFile();
        },
        []
    );

    const getFileTypeList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/content/type/file/', {"headers": headers})
            .then(res => {
                setFileTypeList(res.data)
            })

    }


    const handleBody = e => {
        setMailText(e);
    };

    const inputMessageRecipientList = (deger) => {
        if (deger !== undefined) {
            if (deger.length >= 3) {
                messageSubmit(deger.trim())

            } else {
                setCodes([])
            }
        }
    }
    const handleImageChange = (e) => {

        let files = e.files;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                cmflFilePath.push(reader.result)
            };

        }
    }

    const messageSubmit = (recipient_name) => {
        // setDialog(true)
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/messageProcess/" + recipient_name + "/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false)
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false)
                        const data = res.data;
                        if (data) {
                            // setDialog(false)
                            setCodes(data.code_list)
                        } else {

                            // setDialog(false)
                            showError(data.message);
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })
        }
    }

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            detail: message,
            life: 3000
        });
    }

    const submit = () => {

        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        const obj = {
            mailText: mailText,
            mailTitle: mailTitle,
            mailUser: mailUser,
            receiverName: receiverName

        };


        axios.post('/api/mail-send/', obj, {"headers": headers})
            .then(res => {
                const data = res.data
                if (data.result) {
                    setReceiverName('')
                    showSuccess(data.message);
                    // setData(data.result)
                } else {
                    showError(data.message);
                    // this.setState({disable_submit_btn: false});
                }

            })
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return {status: res.status, data};

                    })
                } else {
                    //console.log("Server Error!");
                    throw res;
                }
            })
        setMailText('')
        setMailTitle('')
            .then(res => {
                if (res.status === 401) {
                    props.loadUser();
                    throw res.data;

                } else if (res.status === 403) {
                    throw res.data;

                }
            })
    }

    const selectedCountriesTemplate = (option) => {
        if (option) {

            return (
                <div className="country-item country-item-value">

                    <div>{option.name}</div>
                </div>
            );
        }

        return "Alıcılar";
    }

    const mailUsers = [
        {name: 'e-Bülten Kullanıcıları', code: 1},
        {name: 'Tüm Kullanıcılar', code: 2},
        {name: 'Kullanıcıları Seç', code: 3},
    ];

    let all_table_header_tabpanel = (

        <div className="p-mt-1">
            <h6><b>Dosya Yükle </b></h6>
        </div>


    );

    let all_table_header_tabpanel2 = (

        <div className="p-mt-1">
            <h6><b>Eklenen Medyalar</b></h6>
        </div>

    );


    // const footer = (item) => {
    //     return (
    //         <div>
    //             <Button icon="pi pi-search"
    //                     onClick={() => editDialog2("image/png", item.cmfl_filepath)}
    //                     className="p-button-rounded p-button-success p-mr-4"/>
    //             <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-outlined"
    //                     onClick={() => deleteRow(item['cmfl_id'])}
    //             />
    //         </div>
    //     )
    // }

    const cardItemsAllContent = (item) => {

        if (item.file_type === "image") {

            return (
                <Card title={footer2(item)}
                      style={{width: '20rem', marginBottom: '2em'}}
                      className="p-mr-5 p-mb-5 p-md-2">
                    <img src={item.cmfl_filepath} className="p-md-12" style={{width: '200px', height: '200px'}}/>
                </Card>
            )
        }
    }

    const footer2 = (item) => {
        return (
            <div>
                <Checkbox value={item} onChange={onCityChange}
                          checked={cities.indexOf(item) !== -1}/>
            </div>
        )
    }

    const onCityChange = (e) => {
        const baseUrl = "https://platform.ssyz.org.tr/"
        const testImage = "/contents/file_upload/thumbnail/400/75/9a69c17d-1a39-4efe-954b-71b92ce37574.png"
        const test = mailText.split("</p>")
        let selectedCities = [...cities];
        setMailText(test[0] + "<br></br>" + "<img  src=" + baseUrl + e.value.cmfl_filepath + "></img>")


        if (e.checked)
            selectedCities.push(e.value);
        else
            selectedCities.splice(selectedCities.indexOf(e.value), 1);

        setCities(selectedCities);

    }

    const submitContentFile = () => {

        const obj = {
            cmflID: cmflID,
            cmflFileName: cmflFileName,
            cmflFilePath: cmflFilePath,
            ctyp_id: typeID,
            fileTypeID: fileTypeID,
        };

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(obj);
            fetch("/contents/image_upload/", {headers, method: "POST", body})

                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {

                        getContentFile()


                        const data = res.data;
                        if (data.result) {
                            setFileTypeID('')

                            showSuccess(data.message);

                            setCmflFileName('')
                            setCmflFilePath([])
                            setCmflDetail('')
                            setActiveIndex1(1)


                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401 || res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    const getContentFile = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/content_image_mail/', {"headers": headers})
            .then(res => {
                const res_file = res.data.result_file
                if (res_file !== null && res_file !== undefined) {
                    setFileList(res_file)

                }
            })
    }


    if (send_mail_role) {


        return (
            <div className="p-fluid" style={{fontSize: 'large'}}>
                <Toast ref={toast}/>
                <Spinner loadingState={loadingState}/>

                <Panel>
                    <Dialog header="Dosya Ekle"
                            visible={cmflDialog}
                            style={{
                                width: "50%",
                                height: "50%"
                            }}

                            onHide={() => setCmflDialog(false)} maximizable>

                        <TabView className="tabview-custom" activeIndex={activeIndex1}
                                 onTabChange={(e) => setActiveIndex1(e.index)}>

                            <TabPanel header={all_table_header_tabpanel} classname="p-mr-2">

                                <div className="p-grid p-mb-3">
                                    {/*<div className="p-col-12 p-md-12">*/}

                                    {/*    <Dropdown*/}
                                    {/*        options={FiletypeOptionItems}*/}
                                    {/*        onChange={(e) => setFileTypeID(e.target.value)}*/}
                                    {/*        value={fileTypeID}*/}
                                    {/*        filter={true}*/}
                                    {/*        showClear={true}*/}
                                    {/*        required={true}*/}
                                    {/*        placeholder="Dosya Türünü Seçiniz"/>*/}
                                    {/*</div>*/}

                                    <div className="p-col-12 p-md-12" align="left">

                                        <FileUpload
                                            multiple accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"
                                            maxFileSize={5000000}
                                            onSelect={handleImageChange}
                                            uploadLabel="Yükle"
                                            chooseLabel="Seç"
                                            cancelLabel="İptal"

                                        />


                                    < /div>
                                    <div>


                                    </div>
                                    <div className="p-mt-6">
                                        <Button label="Ekle" icon="pi pi-check" className="p-button-success"
                                                onClick={() => submitContentFile()} style={{marginTop: '200%'}}/>
                                    </div>


                                </div>
                            </TabPanel>
                            <TabPanel header={all_table_header_tabpanel2}>

                                <div className="p-grid p-md-12">
                                    <div className="p-col-12 p-md-12 p-mb-4">
                                        <Message severity="info"
                                                 text="Uyarı: Resimleri ve videoları sol üstlerindeki seçim kutucuğuna tıklayarak editöre ekleyebilirsiniz. "/>
                                    </div>
                                    <DataView value={fileList}
                                              layout={'grid'}
                                              itemTemplate={cardItemsAllContent}
                                              paginator
                                              rows={6}
                                              emptyMessage="Kayıt Bulunamadı."
                                    />
                                </div>

                            </TabPanel>

                        </TabView>
                    </Dialog>
                    <Card className="p-card-content">

                        <div className="p-grid">
                            <div className="p-col-10 p-md-offset-1" align="center">

                                <div className="p-col-12 p-md-12">

                                    <Fieldset legend="E-Mail Gönder" toggleable>
                                        <div className="p-col-12 p-md-12">

                                            <Dropdown value={mailUser} options={mailUsers}
                                                      onChange={(e) => setMailUser(e.value)}
                                                      optionLabel="name" placeholder="Alıcı Seçiniz"/>

                                        </div>


                                        <div className="p-col-12 p-md-12">
                                            <MultiSelect value={receiverName} options={codes} style={{
                                                width: '100%',
                                                display: mailUser ? mailUser.code === 3 ? 'block' : 'none' : 'none'


                                            }}
                                                         selectedItemsLabel="{0} kullanıcı seçildi"
                                                         selectedItemTemplate={selectedCountriesTemplate}
                                                         onChange={(e) => setReceiverName(e.value)} optionLabel="name"
                                                         filter
                                                         placeholder="Alıcılar" emptyFilterMessage="Bulunamadı"
                                                         onFilter={(e => inputMessageRecipientList(e.filter))}

                                            />
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <InputText
                                                value={mailTitle}
                                                onChange={(e) => setMailTitle(e.target.value)}
                                                name="text"
                                                id="text"
                                                minLength={2}
                                                maxLength={50}
                                                required
                                                placeholder="Başlık Ekle"

                                                className="p-inputtext-lg p-d-block"
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-4">

                                            <Button label="Medya & Dosya Ekle" icon="pi pi-camera"
                                                    onClick={() => setCmflDialog(true)}

                                                    className="p-mb-3 p-mt-3 p-ml-2 p-button-label"/>
                                        </div>
                                        <div className="p-col-12 p-md-12" align="left">

                                            <ReactQuill
                                                style={{
                                                    maxHeight: '600px',
                                                    overflowY: 'scroll',
                                                    overflowX: 'block'
                                                }}
                                                placeholder="Birşeyler yaz"
                                                modules={MyEditor.modules}
                                                formats={MyEditor.formats}
                                                onChange={handleBody}
                                                value={mailText}

                                            >

                                            </ReactQuill>

                                        </div>

                                    </Fieldset>

                                </div>

                            </div>


                        </div>


                        <div className="p-col-12 p-md-12" align="center">

                            <div className="p-mt-2">

                                <Button label="Gönder" icon="pi pi-check" className="p-button-secondary"
                                        onClick={submit}
                                        style={{height: '40px', width: '15%'}}/>
                            </div>
                        </div>
                    </Card>

                </Panel>
            </div>
        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CmsSendMail);



// WEBPACK FOOTER //
// ./src/pages/cmsmanagement/CmsSendMail.jsx